import React from 'react';
import { X, Megaphone } from 'lucide-react';
import ModalShell from '../shared/ModalShell';

const VendorBroadcastModal = ({ isOpen, onClose, notification }) => {
 const title = notification?.title || 'Broadcast';
 const message = notification?.message || '';
 const createdAt = notification?.created_at
 ? new Date(notification.created_at).toLocaleString('en-US', {
 dateStyle: 'medium',
 timeStyle: 'short',
 })
 : '';

 return (
 <ModalShell
 isOpen={isOpen}
 onClose={onClose}
 labelledBy="vendor-broadcast-title"
 panelClassName="max-w-lg"
 >
 <div className="bg-surface rounded-lg shadow-sm max-w-lg w-full border border-border overflow-hidden">
 <div className="p-6">
 <div className="flex items-start justify-between gap-4 mb-4">
 <div className="flex items-center gap-3">
 <div className="flex-shrink-0 w-12 h-12 bg-surface-muted border border-border rounded-xl flex items-center justify-center">
 <Megaphone className="w-6 h-6 text-ink" />
 </div>
 <div>
 <span className="inline-block px-2.5 py-0.5 bg-surface-muted text-ink text-xs font-medium rounded-full mb-1">
 Broadcast from Admin
 </span>
 <h3 id="vendor-broadcast-title" className="text-lg font-semibold text-ink">
 {title}
 </h3>
 {createdAt && (
 <p className="text-xs text-ink-tertiary mt-0.5">{createdAt}</p>
 )}
 </div>
 </div>
 <button
 type="button"
 onClick={onClose}
 className="p-2 text-gray-400 hover:text-gray-600 hover:bg-surface-muted rounded-md transition-colors"
 aria-label="Close"
 >
 <X className="w-5 h-5" />
 </button>
 </div>
 <div className="border-t border-border pt-4">
 <p className="text-sm text-ink-secondary whitespace-pre-wrap leading-relaxed">
 {message}
 </p>
 </div>
 <div className="mt-6 flex justify-end">
 <button
 type="button"
 onClick={onClose}
 className="px-4 py-1.5 text-xs font-medium text-white bg-gray-900 rounded-md hover:bg-gray-800 transition-colors"
 >
 Close
 </button>
 </div>
 </div>
 </div>
 </ModalShell>
 );
};

export default VendorBroadcastModal;
